import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=510e417a&scoped=true"
import script from "./steps.vue?vue&type=script&lang=js"
export * from "./steps.vue?vue&type=script&lang=js"
import style0 from "./steps.vue?vue&type=style&index=0&id=510e417a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e417a",
  null
  
)

export default component.exports